import { useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";

import BeforeAfterCommands from "components/BeforeAfterCommands";
import { Commands } from "components/BeforeAfterCommands/types";
import Counter from "ds/components/Counter";
import { useToggle } from "hooks/useToggle";
import useTypedContext from "hooks/useTypedContext";
import { phases } from "utils/hooks";
import CardCollapsible from "ds/components/Card/Collapsible";

import { ContextContext } from "../Context";
import { ContextHooksFormFields, ContextHooksListItemProps } from "./types";

const ContextHooksItem = ({ item }: ContextHooksListItemProps) => {
  const { canUpdateContext } = useTypedContext(ContextContext);
  const { watch, setValue } = useFormContext<ContextHooksFormFields>();
  const allCommands = watch("hooks");

  const [isCollapsed, handleToggle] = useToggle(true);
  const [commands, setCommands] = useState<Commands>(allCommands[item]);

  const commandsCounter = useMemo(() => {
    return Object.values(commands).flat().length;
  }, [commands]);

  const handleCommandsChange = (commands: Commands) => {
    if (commands.before) {
      setCommands((prevState: Commands) => ({
        ...prevState,
        before: commands.before,
      }));

      setValue(`hooks.${item}.before`, commands.before, { shouldValidate: true });
    }

    if (commands.after) {
      setCommands((prevState: Commands) => ({
        ...prevState,
        after: commands.after,
      }));

      setValue(`hooks.${item}.after`, commands.after, { shouldValidate: true });
    }
  };

  return (
    <CardCollapsible
      title={phases[item]}
      ariaLevel={3}
      ariaLabel={phases[item]}
      titleSuffix={commandsCounter > 0 && <Counter count={commandsCounter} />}
      isCollapsed={isCollapsed}
      onToggle={handleToggle}
    >
      <BeforeAfterCommands
        commands={commands}
        onChange={handleCommandsChange}
        // TODO: [AAC] Needs design for disabled access
        readOnly={!canUpdateContext.result}
      />
    </CardCollapsible>
  );
};

export default ContextHooksItem;
